import React, {useState} from "react";
import style from "styled-components";
import Button from "@mui/material/Button";
import {styled} from "@mui/system";
import {useEthers} from "@usedapp/core";
import CardContentTitle from "../CardContentTitle";
import ConnectWalletModal from "../../ConnectWalletModal";
function ConnectWalletCard({stackingPool}) {
  const {activateBrowserWallet} = useEthers();
  const [walletModal, setWalletModal] = useState(false);
  const handleOpenModal = () => {
    setWalletModal(!walletModal);
  };

  return (
    <>
      <CardContainer>
        <CardContentTitle stackingPool={stackingPool} />
        <>
          {walletModal && (
            <ConnectWalletModal
              walletModal={walletModal}
              setWalletModal={setWalletModal}
            />
          )}
        </>

        <FlexCenterContainer>
          <StackingButton variant="contained" onClick={handleOpenModal}>
            Connect Wallet
          </StackingButton>
        </FlexCenterContainer>
      </CardContainer>
    </>
  );
}

export default ConnectWalletCard;

const CardContainer = style.div`
height:60%;
padding:15px;

`;

const FlexCenterContainer = style.div`
display:flex;
align-items: center;
justify-content:center;
`;
const StackingButton = styled(Button)`
  width: 90%;
  background: none;
  border: 1px solid #fff;
  padding: 15px;
  margin-top: 30px;
  border-radius: 1.5rem;
  border: 2px solid black;
  box-shadow: rgb(0 0 0) 0px 0px 15px;
  background-color: rgba(0, 0, 0, 0.5);
  color: black;
  font-weight: bold;
  color: #fff;
  font-size: 1rem;
  &:hover {
    background-color: rgba(0, 208, 255, 0.473);
  }
`;
